import './style.scss'
import utility from "src/utils/utility"
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import { AppSpan, AppText, Button, Circle, CustomContainer, FlexColumn, FlexRow, GridContainer, PageWrapper } from "src/style"
import { IoIosArrowBack } from "react-icons/io";
import ProfileBgImg from 'src/assets/img/profile-bg-img.svg'
import UserPics from 'src/assets/img/profile-pics.jpg'
import { PasswordChange, ProfileUpdate } from 'src/popup';
import EditIcon from 'src/assets/svg/edit-icon'

const MyProfile = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {decisionBox} = useContext(VisibilityContext)
    const {info: {userData, profileTypeAccess}} = useContext(AppInfoContext)
    const [user, setUser] = useState<any>(null)
    const [accessType, setAccessType] = useState(profileTypeAccess)
    const [view, setView] = useState('')

    useEffect(() => {
        if (userData) setUser(userData)
    }, [userData])

    useEffect(() => {
        if (profileTypeAccess) setAccessType(profileTypeAccess)
    }, [profileTypeAccess])

    function handlePasswordChange () {
        decisionBox.show(
            `Are you sure you want to reset password?`,
            () => setView('change-password'),
            decisionBox.hide,
            `Yes, Reset`,
            'No'
        )
    }

    return (
        <>
            <PageWrapper>
                <CustomContainer topMargin='2.5'>
                    <FlexRow justifyContent='space-between' gap='2'>
                        <FlexRow 
                            justifyContent='flex-start' gap='1'
                            width='auto' sizeUnit=''
                            onClick={() => navigate(-1)}
                        >
                            <AppSpan textSize='2' cursor='pointer' >
                                <IoIosArrowBack />
                            </AppSpan>
                            <AppText 
                                textSize='3' fontWeight="500" color='#101828' cursor='pointer'
                            >
                                Profile
                            </AppText>
                        </FlexRow>
                        <EditIcon 
                            onClick={() => setView('profile-update')}
                        />
                    </FlexRow>
                    <CustomContainer 
                        maxHeight='17.6' radius='0.46'
                        height='17.6' topMargin='2'
                    >
                        <img 
                            src={ProfileBgImg} 
                            className='img-covered' 
                            style={{width: '100%', objectFit: 'cover'}} 
                        />
                    </CustomContainer>
                    <FlexRow 
                        justifyContent='space-between' topMargin='-6.5' 
                        alignItems='stretch' bottomPadding='3'
                        gap='1.5' leftPadding='2' rightPadding='2'
                        className='profile-content-wrapper'
                    >
                        <FlexColumn 
                            bgColor='#ffffff' width='20.9' minHeight='22.3' 
                            radius='0.8' padding='2'
                            shadow='0px 4px 20.7px 0px #0000000D'
                            className='profile-pics-container'
                        >
                            <Circle 
                                size='9.2' bgColor='#0A756F' //bgColor='#DBDBDB' 
                                bottomMargin='1.5'
                                style={{overflow: 'hidden'}}
                            >
                                <AppText 
                                    textSize='2.7' color='#ffffff' 
                                    fontWeight='600' cursor='pointer'
                                >
                                    {user?.firstName?.[0]}{user?.lastName?.[0]}
                                </AppText>
                                {/* <img src={user?.profilePictureUrl || UserPics} className='img-covered' /> */}
                            </Circle>
                            <GridContainer>
                                <AppSpan 
                                    color='#58595B' fontWeight="600"
                                >
                                    {user?.firstName} {user?.lastName}
                                </AppSpan>
                                <AppText color='#A098AE' align='center'>{user?.email}</AppText>
                            </GridContainer>
                        </FlexColumn>
                        <FlexColumn 
                            className='profile-details-container'
                            bgColor='#ffffff' minHeight='16.7'
                            radius='0.8' padding='2.5' justifyContent='space-between'
                            shadow='0px 4px 20.7px 0px #0000000D'
                        >
                            <FlexRow 
                                justifyContent='space-between' 
                                alignItems='flex-start'
                                gap='5' wrap='wrap'
                            >
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#333542' fontWeight="600">Full name</AppText>
                                    <AppSpan>{user?.firstName} {user?.lastName}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#333542' fontWeight="600">Username</AppText>
                                    <AppSpan>{user?.userName}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#333542' fontWeight="600">Email</AppText>
                                    <AppSpan>{user?.email}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#333542' fontWeight="600">Phone number</AppText>
                                    <AppSpan>{user?.phoneNumber}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#333542' fontWeight="600">Status</AppText>
                                    <GridContainer 
                                        width='6.5' height='2.2' radius='1.6' 
                                        bgColor={user?.status === 'Active' ? '#ECFDF3' : '#FFEBEA'}
                                    >
                                        <AppSpan 
                                            textSize='1.2' fontWeight="500" 
                                            color={user?.status === 'Active' ? '#027A48' : '#D30202'}
                                        >
                                            {user?.status || 'Inactive'}
                                        </AppSpan>
                                    </GridContainer>
                                </CustomContainer>
                            </FlexRow>
                            {/* <FlexRow justifyContent='flex-end' gap='1.5' wrap='wrap' topMargin='2'>
                                {
                                    <Button
                                        width='15.9'
                                        titleSize='1.4' fontWeight="500"
                                        height='4' radius='0.8'
                                        hoverColor='#0D968F'
                                        hoverBgColor='#fff' borderColor='#0D968F'
                                        onClick={handlePasswordChange}
                                    >
                                        Change Password
                                    </Button>
                                }
                            </FlexRow> */}
                        </FlexColumn>
                    </FlexRow>
                </CustomContainer>
            </PageWrapper>
            { view === 'change-password' &&
                <PasswordChange
                    close={() => setView('')} 
                />
            }
            { view === 'profile-update' &&
                <ProfileUpdate
                    close={() => setView('')} 
                />
            }
        </>
    )
}

export default utility.routeData('profile', 'Profile', <MyProfile/>)